export const getPlanSubtitle = (planData) => {
  if (!planData) {
    return '';
  }

  if (planData === 'Unlimited') {
    return 'Pro';
  }

  if (planData === 'Parking' || planData < 300) {
    return 'Starter';
  } else if (planData < 450) {
    return 'Entertainment';
  } else if (planData < 800) {
    return 'Optimal';
  } else {
    return 'Pro';
  }
};
